/**
 * Estilos da aba Exceções: lista com divisórias (não mural), caixa de
 * seleção à esquerda, nome e situação no meio, a sugestão ou a marca à
 * direita. Nada de rolagem lateral: o meio encolhe com reticências.
 */
import styled from "styled-components";

import { BP_MOBILE } from "../../styles/canonical/breakpoints";

const tabletAcima = `(min-width: ${BP_MOBILE + 1}px)`;
const tom = (nome, parte) => `var(--${nome || "neutral"}-${parte})`;

/* Barra do lote: aparece com algo selecionado, logo acima das listas. */
export const BarraDoLote = styled.section`
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
  padding: 12px 14px;
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 12px;
  background: ${({ theme }) => theme.surfaceAlt};

  > [role="group"] {
    align-self: flex-start;
  }

  .resumo {
    font-size: 13px;
    font-weight: 650;
    color: ${({ theme }) => theme.textPrimary};
  }

  .erro {
    margin: 0;
    font-size: var(--text-min, 12px);
    color: ${({ theme }) => theme.textSecondary};
  }
`;

export const CamposDoLote = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 10px;
  min-width: 0;

  label {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1 1 180px;
    min-width: 0;
    font-size: var(--text-min, 12px);
    font-weight: 600;
    color: ${({ theme }) => theme.textSecondary};
  }

  input,
  select {
    min-height: 36px;
    width: 100%;
    max-width: 100%;
    padding: 5px 10px;
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.border};
    background: ${({ theme }) => theme.surface};
    color: ${({ theme }) => theme.textPrimary};
    font: inherit;
    /* 16px no celular: abaixo disso o iOS dá zoom ao focar. */
    font-size: 16px;
  }

  @media ${tabletAcima} {
    input,
    select {
      font-size: 13px;
    }
  }
`;

export const AcoesDoLote = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`;

/* Cabeçalho de cada lista: título + atalhos de seleção. */
export const CabecalhoLista = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 4px 12px;
  min-width: 0;
`;

/* Uma linha de ambiente: [caixa] [nome / situação] [sugestão ou marca]. */
export const LinhaExcecao = styled.li`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  column-gap: 12px;
  align-items: start;
  min-width: 0;
  padding: 10px 14px;

  & + & {
    border-top: 1px solid ${({ theme }) => theme.border};
  }

  input[type="checkbox"] {
    margin-top: 2px;
  }

  .texto {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  .nome {
    min-width: 0;
    font-size: 13px;
    font-weight: 550;
    color: ${({ theme }) => theme.textPrimary};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
  }

  .sub {
    min-width: 0;
    font-size: var(--text-min, 12px);
    color: ${({ theme }) => theme.textTertiary};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .bloqueio {
    font-size: var(--text-min, 12px);
    line-height: 1.4;
    color: ${tom("warning", "text")};
    overflow-wrap: anywhere;
  }

  .obs {
    font-size: var(--text-min, 12px);
    line-height: 1.4;
    color: ${({ theme }) => theme.textSecondary};
    overflow-wrap: anywhere;
  }

  .marca {
    font-size: var(--text-min, 12px);
    font-weight: 600;
    color: ${({ theme }) => theme.textSecondary};
    white-space: nowrap;
    text-align: right;
  }

  @media ${tabletAcima} {
    padding: 10px 18px;
  }
`;

export const ListaExcecoes = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  min-width: 0;
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 12px;
  background: ${({ theme }) => theme.surface};
  overflow: hidden;
`;
